import React, {memo, useEffect} from 'react'
import {Accordion, Breadcrumb, Grid, Menu, Segment} from 'semantic-ui-react'
import {goTo} from '../../util'
import {useSafeState} from '../../hook'
import {GettingStartedSection} from './sections/getting-started'
import {HowToMenu, HowToSection} from './sections/how-to'
import {UseCasesSection} from './sections/use-cases'
import {ReferenceSection} from './sections/reference'
import {ApiSection} from './sections/api'
import {CLISection} from './sections/cli'
import {Redirect, Router} from '@reach/router'
import {kebabCase} from 'lodash'

const menuSections = [
  {
    name: 'Getting Started',
    component: React.Fragment,
    expandable: false
  },
  {
    name: 'How To',
    component: HowToMenu,
    expandable: true
  },
  // {
  //   name: 'Reference',
  //   component: ReferenceMenu,
  //   expandable: true
  // },
  // {
  //   name: 'Use Cases',
  //   component: UseCasesMenu,
  //   expandable: true
  // },
  {
    name: 'API',
    component: React.Fragment
  },
  {
    name: 'CLI',
    component: React.Fragment
  }
]

const _Docs = ({navigate, location, activeIndex}) => {
  const [state, setState] = useSafeState({activeIndex: -1})

  useEffect(() => {
    setState({activeIndex})
  }, [activeIndex])

  const onMenuItemClick = (e, {name}) => {
    navigate(`/c/docs/${kebabCase(name.toLowerCase())}`)
  }

  const onAccordionTitleClick = (e, titleProps) => {
    const {index} = titleProps
    const {activeIndex} = state
    const newIndex = activeIndex === index ? -1 : index
    setState({activeIndex: newIndex})
  }

  return (
    <Grid divided='vertically'>
      <Grid.Row coloumns='16'>
        <Grid.Column width='16'>
          <Breadcrumb>
            <Breadcrumb.Section link
                                onClick={() => goTo(`${process.env.REACT_APP_SITE_URL}`)}>Home</Breadcrumb.Section>
            <Breadcrumb.Divider/>
            <Breadcrumb.Section active>Docs</Breadcrumb.Section>
          </Breadcrumb>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns='16'>
        <Grid.Column width='4'>
          <Accordion as={Menu} vertical size='huge'>
            {
              menuSections.map((menuSection, idx) => {
                const Component = menuSection.component

                if (menuSection.expandable) {
                  return (
                    <Menu.Item key={menuSection.name}>
                      <Accordion.Title
                        key={`accordion-title-${menuSection.name}`}
                        active={state.activeIndex === idx}
                        content={menuSection.name}
                        index={idx}
                        onClick={onAccordionTitleClick}
                      />
                      <Accordion.Content key={`accordion-content-${menuSection.name}`}
                                         active={state.activeIndex === idx}
                                         content={<Component {...{navigate, location}}/>}/>
                    </Menu.Item>
                  )
                }

                return (
                  <Menu.Item
                    key={menuSection.name}
                    name={menuSection.name}
                    active={menuSections[state.activeIndex] && menuSections[state.activeIndex].name === menuSection.name}
                    onClick={onMenuItemClick}
                  >
                    {menuSection.name}
                  </Menu.Item>
                )
              })
            }
          </Accordion>
        </Grid.Column>
        <Grid.Column width='12'>
          <Segment>
            <Router>
              <GettingStartedSection default path='getting-started/*'/>
              <HowToSection path='how-to/*'/>
              <UseCasesSection path='use-cases/*'/>
              <ReferenceSection path='reference/*'/>
              <ApiSection path='api'/>
              <CLISection path='cli'/>
            </Router>
          </Segment>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

let Docs = (props) => {
  const {location} = props
  const matchingMenuSection = menuSections.find(ms => {
    return location.pathname.indexOf(kebabCase(ms.name.toLowerCase())) > -1
  })
  let activeIndex = 0
  if (matchingMenuSection) {
    activeIndex = menuSections.indexOf(matchingMenuSection)
  }

  props = {...props, activeIndex}
  return <_Docs {...props}/>
}
Docs = memo(Docs)

export {_Docs, Docs}

export default Docs